import { useLocation } from 'react-router-dom';
import { useGetFiltersListAPI } from 'packages/omnitag/api/use-get-filters-api';

// Aug-13-2025 - Used Gemini 2.5 Agent to create useActiveFilterCount

export const useActiveFilterCount = (): number => {
  const filtersSWR = useGetFiltersListAPI();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  let count = 0;

  const dynamicFilters = filtersSWR.data?.filters ?? [];
  const filterParams = ['logNames', ...dynamicFilters.map((f) => f.paramName)];

  for (const param of filterParams) {
    const filterConfig = dynamicFilters.find((f) => f.paramName === param);
    let paramToCheck = param;
    if (filterConfig?.filterType === 'dateRange') {
      paramToCheck = `${param}From`;
    }

    if (searchParams.has(paramToCheck)) {
      const value = searchParams.get(paramToCheck);
      if (value && value.length > 0) {
        // Don't count filter items in the URL that are set to their default value
        // We only want what the user has set/modified
        if (filterConfig && 'defaultValue' in filterConfig) {
          if (value !== String(filterConfig.defaultValue)) {
            count++;
          }
        } else {
          count++;
        }
      }
    }
  }
  return count;
};
